import React from "react";
import Checkbox from '@material-ui/core/Checkbox';
import LegalDialog from "../LegalDialog"
import Button from '@material-ui/core/Button';


class Legal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            service: false,
            protection: false,
            open: false,
            legal: null,
            serviceActionDisabled: true,
            protectionActionDisabled: true,
        }
    }

    onScrollEnd = (legal) => {
        this.setState({[`${legal}ActionDisabled`]: false})
    };

    handleClickOpen = legal => () => {
        this.setState({open: true, legal});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    actionHandler = accepted => () => {
        const {legal} = this.state;
        this.setState({[legal]: accepted, open: false}
            , () => {
                const {service, protection} = this.state;
                this.props.onComplete({status: service && protection, pack: this.props.pack})
            });
    };

    floorPlanCheckHandler = (e) => {
        const {onFloorPlanCheck} = this.props;
        onFloorPlanCheck()
    };

    nofloorPlanCheckHandler = (e) => {
        const {onNoFloorPlanCheck} = this.props;
        onNoFloorPlanCheck()
    };

    render() {
        const {service, protection} = this.state;
        const {code, nofloorPlanChecked, floorPlanChecked} = this.props;
        return (
            <div>
                <div className={"legal"}>
                    <div className={"legal-checkbox"}>
                        <Checkbox
                            checked={service}
                            value={'legalService'}
                            id={'service'}
                            disabled={true}
                            style={{width: 36, height: 36}}
                        />
                    </div>
                    <Button
                        onClick={this.handleClickOpen('service')}
                        fullWidth
                        style={{color: '#fff'}}
                        className={"legal-button"}
                    >
                        {"Όροι Χρήσης"}
                    </Button>
                </div>
                <div className={"legal"}>
                    <div className={"legal-checkbox"}>
                        <Checkbox
                            checked={protection}
                            value={'legalProtection'}
                            id={'protection'}
                            disabled={true}
                            style={{width: 36, height: 36}}
                        />
                    </div>
                    <Button
                        onClick={this.handleClickOpen('protection')}
                        fullWidth
                        style={{color: '#fff'}}
                        className={"legal-button"}
                    >
                        {"Ειδοποίηση Ιδιωτικότητας"}
                    </Button>
                </div>
                {code === "003"
                    ? (<div>
                        <div className={"legal"}>
                            <div className={"legal-checkbox"}>
                                <Checkbox
                                    checked={floorPlanChecked}
                                    value={'floorPlanValue'}
                                    id={'floorPlanId'}
                                    disabled={true}
                                    style={{width: 36, height: 36}}
                                />
                            </div>
                            <Button
                                onClick={this.floorPlanCheckHandler}
                                fullWidth
                                style={{color: '#fff'}}
                                className={"legal-button"}
                            >
                                {"Διαθέτω κάτοψη (σχέδιο) κατοικίας (χωρίς πρόσθετη χρέωση)"}
                            </Button>
                        </div>
                        <div className={"legal"}>
                            <div className={"legal-checkbox"}>
                                <Checkbox
                                    checked={nofloorPlanChecked}
                                    value={'floorPlanValue'}
                                    id={'floorPlanId'}
                                    disabled={true}
                                    style={{width: 36, height: 36}}
                                />
                            </div>
                            <Button
                                onClick={this.nofloorPlanCheckHandler}
                                fullWidth
                                style={{color: '#fff'}}
                                className={"legal-button"}
                            >
                                {"Δεν διαθέτω κάτοψη (σχέδιο) κατοικίας (με πρόσθετη χρέωση)"}
                            </Button>
                        </div>
                    </div>)
                    : null}
                <LegalDialog
                    open={this.state.open}
                    handleClose={this.handleClose}
                    actionHandler={this.actionHandler}
                    legal={this.state.legal}
                    pack={this.props.pack}
                    serviceActionDisabled={this.state.serviceActionDisabled}
                    protectionActionDisabled={this.state.protectionActionDisabled}
                    onScrollEnd={this.onScrollEnd}
                />

            </div>
        );
    }
}

export default Legal;